const EUR = 'EUR';

export { EUR };
